import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63dc114a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "content-block" }, "Ejecucion Orden Trabajo - Estudios", -1))
const _hoisted_2 = { class: "content-block" }
const _hoisted_3 = { class: "dx-card responsive-paddings" }
const _hoisted_4 = { id: "form-container" }
const _hoisted_5 = { id: "form-demo" }
const _hoisted_6 = { class: "widget-container" }
const _hoisted_7 = { class: "form" }
const _hoisted_8 = { class: "dx-fieldset" }
const _hoisted_9 = { class: "dx-field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Descripción", -1))
const _hoisted_11 = { class: "dx-field-value" }
const _hoisted_12 = { class: "dx-field" }
const _hoisted_13 = { class: "dx-field-value" }
const _hoisted_14 = { class: "dx-field" }
const _hoisted_15 = { class: "dx-field-value" }
const _hoisted_16 = { class: "dx-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Recibío", -1))
const _hoisted_18 = { class: "dx-field-value" }
const _hoisted_19 = { class: "dx-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Fecha Entrega", -1))
const _hoisted_21 = { class: "dx-field-value" }
const _hoisted_22 = { class: "dx-field" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Fecha Compromiso Entrega", -1))
const _hoisted_24 = { class: "dx-field-value" }
const _hoisted_25 = { class: "dx-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Responsabilidad Entrega", -1))
const _hoisted_27 = { class: "dx-field-value" }
const _hoisted_28 = { class: "dx-field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Observaciones", -1))
const _hoisted_30 = { class: "dx-field-value" }
const _hoisted_31 = { class: "form" }
const _hoisted_32 = { class: "dx-fieldset" }
const _hoisted_33 = { class: "dx-field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Descripción", -1))
const _hoisted_35 = { class: "dx-field-value" }
const _hoisted_36 = { class: "dx-field" }
const _hoisted_37 = { class: "dx-field-value" }
const _hoisted_38 = { class: "dx-field" }
const _hoisted_39 = { class: "dx-field-value" }
const _hoisted_40 = { class: "dx-field" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Fecha Entrega", -1))
const _hoisted_42 = { class: "dx-field-value" }
const _hoisted_43 = { class: "dx-field" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Responsabilidad Entrega", -1))
const _hoisted_45 = { class: "dx-field-value" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h4", null, "Plan de Trabajo Generado")
  ])
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Responsable:", -1))
const _hoisted_48 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_49 = { class: "value" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Tipo Escala:", -1))
const _hoisted_53 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_54 = { class: "value" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"flex-end"} }, [
  /*#__PURE__*/_createElementVNode("p")
], -1))
const _hoisted_58 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_59 = { class: "form" }
const _hoisted_60 = {
  key: 0,
  class: "dx-field"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Con el nuevo estatus deberá capturar información complementaria en la sección correspondiente. ", -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = {
  key: 1,
  class: "dx-field"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Con el nuevo estatus deberá capturar información resolutiva en la sección correspondiente. ", -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Información Resolutivo")
], -1))
const _hoisted_67 = {
  key: 0,
  class: "dx-field"
}
const _hoisted_68 = {
  key: 1,
  class: "dx-field"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Información Complementaria")
], -1))
const _hoisted_70 = {
  key: 0,
  class: "dx-field"
}
const _hoisted_71 = {
  key: 1,
  class: "dx-field"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DxLabel = _resolveComponent("DxLabel")
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")
  const _component_DxGroupItem = _resolveComponent("DxGroupItem")
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")
  const _component_DxSelection = _resolveComponent("DxSelection")
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")
  const _component_DxSorting = _resolveComponent("DxSorting")
  const _component_DxScrolling = _resolveComponent("DxScrolling")
  const _component_DxPaging = _resolveComponent("DxPaging")
  const _component_DxPager = _resolveComponent("DxPager")
  const _component_DxEditing = _resolveComponent("DxEditing")
  const _component_DxButton = _resolveComponent("DxButton")
  const _component_DxColumn = _resolveComponent("DxColumn")
  const _component_DxFormItem = _resolveComponent("DxFormItem")
  const _component_DxValidationRule = _resolveComponent("DxValidationRule")
  const _component_DxLookup = _resolveComponent("DxLookup")
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")
  const _component_DxTextArea = _resolveComponent("DxTextArea")
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")
  const _component_DxTextBox = _resolveComponent("DxTextBox")
  const _component_DxDateBox = _resolveComponent("DxDateBox")
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")
  const _component_DxScrollView = _resolveComponent("DxScrollView")
  const _component_DxPopup = _resolveComponent("DxPopup")
  const _component_DxToast = _resolveComponent("DxToast")
  const _component_DxItem = _resolveComponent("DxItem")
  const _component_DxTasks = _resolveComponent("DxTasks")
  const _component_DxDependencies = _resolveComponent("DxDependencies")
  const _component_DxToolbar = _resolveComponent("DxToolbar")
  const _component_DxValidation = _resolveComponent("DxValidation")
  const _component_DxStripLine = _resolveComponent("DxStripLine")
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")
  const _component_DxContextMenu = _resolveComponent("DxContextMenu")
  const _component_DxGantt = _resolveComponent("DxGantt")
  const _component_DxGrouping = _resolveComponent("DxGrouping")
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")
  const _component_DxEmptyItem = _resolveComponent("DxEmptyItem")
  const _component_DxForm = _resolveComponent("DxForm")
  const _component_DxFileUploader = _resolveComponent("DxFileUploader")
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", {
                action: "your-action",
                onSubmit: _cache[25] || (_cache[25] = (...args) => ($options.handleSubmit && $options.handleSubmit(...args)))
              }, [
                _createVNode(_component_DxForm, {
                  "form-data": $data.customer,
                  "onUpdate:form-data": _cache[24] || (_cache[24] = $event => (($data.customer) = $event)),
                  "read-only": false,
                  "show-colon-after-label": true,
                  "show-validation-summary": true,
                  "validation-group": "customerData",
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxGroupItem, {
                      caption: "Datos Generales",
                      "col-count": 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "numeroordentrabajo",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Numero de Orden de Trabajo" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "estatus",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Estatus" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "cliente",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Cliente" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "servicio",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Servicio" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "etapa",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Etapa de Orden de Trabajo" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "usuarioregistro",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Usuario Genero Orden de Trabajo" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "responsabletecnico",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Responsable Técnico" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSimpleItem, {
                          "data-field": "tipoproyecto",
                          "editor-options": { readOnly: true, width: '100%' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { text: "Tipo Proyecto" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxGroupItem, { caption: "Detalle de Orden Trabajo" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxTabPanel, { scrollByContent: true }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxItem, { title: "Listados de Informacion" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDataGrid, {
                                  id: "procedimientos5",
                                  "data-source": $data.dataSourceEntrega,
                                  "allow-column-reordering": true,
                                  "column-auto-width": true,
                                  "show-row-lines": true,
                                  "show-borders": true,
                                  "word-wrap-enabled": true,
                                  "key-expr": "id",
                                  onInitNewRow: $options.onInitNewRow,
                                  onEditorPreparing: $options.editorPreparingListados
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSelection, { mode: "single" }),
                                    _createVNode(_component_DxSearchPanel, { visible: true }),
                                    _createVNode(_component_DxSorting, { mode: "multiple" }),
                                    _createVNode(_component_DxScrolling, { mode: "standard" }),
                                    _createVNode(_component_DxPaging, {
                                      enabled: true,
                                      "page-size": 100
                                    }),
                                    _createVNode(_component_DxPager, {
                                      "show-page-size-selector": true,
                                      "allowed-page-sizes": _ctx.allowedPageSizes,
                                      "show-info": true
                                    }, null, 8, ["allowed-page-sizes"]),
                                    _createVNode(_component_DxEditing, {
                                      "allow-updating": true,
                                      "allow-adding": false,
                                      "allow-deleting": false,
                                      popup: $data.popupOptionsListado,
                                      mode: "popup"
                                    }, null, 8, ["popup"]),
                                    _createVNode(_component_DxColumn, {
                                      type: "buttons",
                                      width: 50
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          hint: "Editar Resultados",
                                          icon: "edit",
                                          onClick: $options.editListadoInformacion
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "aplica",
                                      caption: "No Aplica",
                                      width: 130,
                                      "data-type": "boolean"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "descripcion",
                                      caption: "Descripcion"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, {
                                          "editor-options": { readOnly: true },
                                          "editor-type": "dxTextArea"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "recibio",
                                      caption: "Nombre Recibio"
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "entregado",
                                      caption: "Entregado",
                                      width: 130
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fechaentrega",
                                      caption: "Fecha Entrega",
                                      "data-type": "date"
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fechacompromisoentrega",
                                      caption: "Fecha Compromiso Entrega",
                                      "data-type": "date"
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "responsabilidadentregaid",
                                      caption: "Responsabilidad Entrega"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxLookup, {
                                          "data-source": $data.dataSourceResponsabilidadEntrega,
                                          "value-expr": "id",
                                          "display-expr": "descripcion"
                                        }, null, 8, ["data-source"]),
                                        _createVNode(_component_DxValidationRule, { type: "required" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "observaciones",
                                      caption: "Observaciones"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, {
                                          "editor-options": { readOnly: false },
                                          "editor-type": "dxTextArea"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fecharegistro",
                                      caption: "Fecha Registro",
                                      "data-type": "date"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "usuarioregistro",
                                      caption: "Usuario"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGroupPanel, { visible: true }),
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSearchPanel, { visible: false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "onInitNewRow", "onEditorPreparing"]),
                                _createVNode(_component_DxPopup, {
                                  ref: "popupedli",
                                  height: 650,
                                  width: 750,
                                  title: $data.popup_li_OptionsListado,
                                  "close-on-outside-click": true,
                                  visible: $data.li_popupVisible,
                                  "onUpdate:visible": _cache[8] || (_cache[8] = $event => (($data.li_popupVisible) = $event)),
                                  "content-template": "popup-content",
                                  showCloseButton: "true"
                                }, {
                                  "popup-content": _withCtx(() => [
                                    _createVNode(_component_DxScrollView, {
                                      height: "100%",
                                      width: "100%"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, [
                                          _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                              _hoisted_10,
                                              _createElementVNode("div", _hoisted_11, [
                                                _createVNode(_component_DxTextArea, {
                                                  "read-only": true,
                                                  height: 60,
                                                  value: $data.v_li_descripcion,
                                                  "onUpdate:value": _cache[0] || (_cache[0] = $event => (($data.v_li_descripcion) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                              _createElementVNode("div", _hoisted_13, [
                                                _createVNode(_component_DxCheckBox, {
                                                  id: "check1",
                                                  text: "NO APLICA",
                                                  value: $data.v_li_aplica,
                                                  "onUpdate:value": _cache[1] || (_cache[1] = $event => (($data.v_li_aplica) = $event)),
                                                  onValueChanged: $options.handleValueChange_li_noaplica
                                                }, null, 8, ["value", "onValueChanged"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                              _createElementVNode("div", _hoisted_15, [
                                                _createVNode(_component_DxCheckBox, {
                                                  id: "check1",
                                                  text: "ENTREGADO",
                                                  value: $data.v_li_entregado,
                                                  "onUpdate:value": _cache[2] || (_cache[2] = $event => (($data.v_li_entregado) = $event)),
                                                  onValueChanged: $options.handleValueChange_li_aplica
                                                }, null, 8, ["value", "onValueChanged"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                              _hoisted_17,
                                              _createElementVNode("div", _hoisted_18, [
                                                _createVNode(_component_DxTextBox, {
                                                  "read-only": false,
                                                  value: $data.v_li_recibio,
                                                  "onUpdate:value": _cache[3] || (_cache[3] = $event => (($data.v_li_recibio) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                              _hoisted_20,
                                              _createElementVNode("div", _hoisted_21, [
                                                _createVNode(_component_DxDateBox, {
                                                  "show-clear-button": true,
                                                  "use-mask-behavior": true,
                                                  "display-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  value: $data.v_li_fechaentrega,
                                                  "onUpdate:value": _cache[4] || (_cache[4] = $event => (($data.v_li_fechaentrega) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                              _hoisted_23,
                                              _createElementVNode("div", _hoisted_24, [
                                                _createVNode(_component_DxDateBox, {
                                                  "show-clear-button": true,
                                                  "use-mask-behavior": true,
                                                  "display-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  value: $data.v_li_fechacompromisoentrega,
                                                  "onUpdate:value": _cache[5] || (_cache[5] = $event => (($data.v_li_fechacompromisoentrega) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_25, [
                                              _hoisted_26,
                                              _createElementVNode("div", _hoisted_27, [
                                                _createVNode(_component_DxSelectBox, {
                                                  "data-source": $data.dataSourceResponsabilidadEntrega ,
                                                  "display-expr": "descripcion",
                                                  "value-expr": "id",
                                                  "show-clear-button": true,
                                                  value: $data.v_li_responsabilidadentregaid,
                                                  "onUpdate:value": _cache[6] || (_cache[6] = $event => (($data.v_li_responsabilidadentregaid) = $event))
                                                }, null, 8, ["data-source", "value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                              _hoisted_29,
                                              _createElementVNode("div", _hoisted_30, [
                                                _createVNode(_component_DxTextArea, {
                                                  height: 80,
                                                  value: $data.v_li_observaciones,
                                                  "onUpdate:value": _cache[7] || (_cache[7] = $event => (($data.v_li_observaciones) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxToolbarItem, {
                                      widget: "dxButton",
                                      location: "after",
                                      toolbar: "bottom",
                                      options: {
                            text: 'Guardar',
                            onClick: $options.saveListadoInformacion,

                          }
                                    }, null, 8, ["options"])
                                  ]),
                                  _: 1
                                }, 8, ["title", "visible"]),
                                _createVNode(_component_DxToast, {
                                  visible: $data.isVisible,
                                  "onUpdate:visible": _cache[9] || (_cache[9] = $event => (($data.isVisible) = $event)),
                                  message: $data.message,
                                  "onUpdate:message": _cache[10] || (_cache[10] = $event => (($data.message) = $event)),
                                  type: $data.type,
                                  "onUpdate:type": _cache[11] || (_cache[11] = $event => (($data.type) = $event))
                                }, null, 8, ["visible", "message", "type"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Documentacion" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDataGrid, {
                                  id: "procedimientos2",
                                  "data-source": $data.dataSourceListados,
                                  "allow-column-reordering": true,
                                  "column-auto-width": true,
                                  "show-row-lines": true,
                                  "show-borders": true,
                                  "word-wrap-enabled": true,
                                  "key-expr": "id",
                                  onInitNewRow: $options.onInitNewRow,
                                  onEditorPreparing: $options.editorPreparingDocumentos
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSelection, { mode: "single" }),
                                    _createVNode(_component_DxSearchPanel, { visible: true }),
                                    _createVNode(_component_DxSorting, { mode: "multiple" }),
                                    _createVNode(_component_DxScrolling, { mode: "standard" }),
                                    _createVNode(_component_DxPaging, {
                                      enabled: true,
                                      "page-size": 100
                                    }),
                                    _createVNode(_component_DxPager, {
                                      "show-page-size-selector": true,
                                      "allowed-page-sizes": _ctx.allowedPageSizes,
                                      "show-info": true
                                    }, null, 8, ["allowed-page-sizes"]),
                                    _createVNode(_component_DxEditing, {
                                      "allow-updating": true,
                                      "allow-adding": false,
                                      "allow-deleting": false,
                                      popup: $data.popupOptions2,
                                      mode: "popup"
                                    }, null, 8, ["popup"]),
                                    _createVNode(_component_DxColumn, {
                                      type: "buttons",
                                      width: 50
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          hint: "Editar Resultados",
                                          icon: "edit",
                                          onClick: $options.editListadoDocumentacion
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "aplica",
                                      caption: "No Aplica",
                                      width: 130
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, { "col-span": 2 })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "descripcion",
                                      caption: "Descripcion"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxFormItem, {
                                          "col-span": 2,
                                          "editor-options": { height: 80, readOnly: true },
                                          "editor-type": "dxTextArea"
                                        }),
                                        _createVNode(_component_DxValidationRule, { type: "required" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "entregado",
                                      caption: "Entregado",
                                      width: 130
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido2)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fechaentrega",
                                      caption: "Fecha Entrega",
                                      "data-type": "date"
                                    }, {
                                      default: _withCtx(() => [
                                        ($data.esCampoRequerido2)
                                          ? (_openBlock(), _createBlock(_component_DxValidationRule, {
                                              key: 0,
                                              type: "required"
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "responsabilidadentregaid",
                                      caption: "Responsabilidad Entrega"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxLookup, {
                                          "data-source": $data.dataSourceResponsabilidadEntrega,
                                          "value-expr": "id",
                                          "display-expr": "descripcion"
                                        }, null, 8, ["data-source"]),
                                        _createVNode(_component_DxValidationRule, { type: "required" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGroupPanel, { visible: true }),
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSearchPanel, { visible: false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "onInitNewRow", "onEditorPreparing"]),
                                _createVNode(_component_DxPopup, {
                                  ref: "popupld",
                                  height: 500,
                                  width: 750,
                                  title: $data.popup_ld_OptionsListado,
                                  "close-on-outside-click": true,
                                  visible: $data.ld_popupVisible,
                                  "onUpdate:visible": _cache[17] || (_cache[17] = $event => (($data.ld_popupVisible) = $event)),
                                  "content-template": "popup-content",
                                  showCloseButton: "true"
                                }, {
                                  "popup-content": _withCtx(() => [
                                    _createVNode(_component_DxScrollView, {
                                      height: "100%",
                                      width: "100%"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_31, [
                                          _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, [
                                              _hoisted_34,
                                              _createElementVNode("div", _hoisted_35, [
                                                _createVNode(_component_DxTextArea, {
                                                  "read-only": true,
                                                  height: 60,
                                                  value: $data.v_ld_descripcion,
                                                  "onUpdate:value": _cache[12] || (_cache[12] = $event => (($data.v_ld_descripcion) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_36, [
                                              _createElementVNode("div", _hoisted_37, [
                                                _createVNode(_component_DxCheckBox, {
                                                  id: "check1",
                                                  text: "NO APLICA",
                                                  value: $data.v_ld_aplica,
                                                  "onUpdate:value": _cache[13] || (_cache[13] = $event => (($data.v_ld_aplica) = $event)),
                                                  onValueChanged: $options.handleValueChange_ld_noaplica
                                                }, null, 8, ["value", "onValueChanged"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_38, [
                                              _createElementVNode("div", _hoisted_39, [
                                                _createVNode(_component_DxCheckBox, {
                                                  id: "check1",
                                                  text: "ENTREGADO",
                                                  value: $data.v_ld_entregado,
                                                  "onUpdate:value": _cache[14] || (_cache[14] = $event => (($data.v_ld_entregado) = $event)),
                                                  onValueChanged: $options.handleValueChange_ld_aplica
                                                }, null, 8, ["value", "onValueChanged"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_40, [
                                              _hoisted_41,
                                              _createElementVNode("div", _hoisted_42, [
                                                _createVNode(_component_DxDateBox, {
                                                  "show-clear-button": true,
                                                  "use-mask-behavior": true,
                                                  "display-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  value: $data.v_ld_fechaentrega,
                                                  "onUpdate:value": _cache[15] || (_cache[15] = $event => (($data.v_ld_fechaentrega) = $event))
                                                }, null, 8, ["value"])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_43, [
                                              _hoisted_44,
                                              _createElementVNode("div", _hoisted_45, [
                                                _createVNode(_component_DxSelectBox, {
                                                  "data-source": $data.dataSourceResponsabilidadEntrega ,
                                                  "display-expr": "descripcion",
                                                  "value-expr": "id",
                                                  "show-clear-button": true,
                                                  value: $data.v_ld_responsabilidadentregaid,
                                                  "onUpdate:value": _cache[16] || (_cache[16] = $event => (($data.v_ld_responsabilidadentregaid) = $event))
                                                }, null, 8, ["data-source", "value"])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxToolbarItem, {
                                      widget: "dxButton",
                                      location: "after",
                                      toolbar: "bottom",
                                      options: {
                            text: 'Guardar',
                            onClick: $options.saveListadoDocumentacion,

                          }
                                    }, null, 8, ["options"])
                                  ]),
                                  _: 1
                                }, 8, ["title", "visible"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Plan" }, {
                              default: _withCtx(() => [
                                _hoisted_46,
                                _createElementVNode("div", null, [
                                  _hoisted_47,
                                  _hoisted_48,
                                  _createElementVNode("div", _hoisted_49, [
                                    _createVNode(_component_DxSelectBox, {
                                      "data-source": $data.dataSourceResponsable,
                                      "input-attr": { 'aria-label': 'Escala' },
                                      "display-expr": "responsable",
                                      "value-expr": "id",
                                      onValueChanged: $options.cambioResponsable,
                                      value: $data.vidotresponsable,
                                      "onUpdate:value": _cache[18] || (_cache[18] = $event => (($data.vidotresponsable) = $event))
                                    }, null, 8, ["data-source", "onValueChanged", "value"])
                                  ]),
                                  _hoisted_50,
                                  _hoisted_51,
                                  _hoisted_52,
                                  _hoisted_53,
                                  _createElementVNode("div", _hoisted_54, [
                                    _createVNode(_component_DxSelectBox, {
                                      "data-source": $data.datosEscala,
                                      "input-attr": { 'aria-label': 'Escala' },
                                      "display-expr": "nombre",
                                      "value-expr": "campo",
                                      onValueChanged: $options.cambioEscala
                                    }, null, 8, ["data-source", "onValueChanged"])
                                  ]),
                                  _hoisted_55,
                                  _hoisted_56,
                                  _createVNode(_component_DxGantt, {
                                    "task-list-width": 500,
                                    height: 700,
                                    "scale-type": $data.tipoEscala,
                                    ref: $data.ganttRef,
                                    onTaskUpdating: $options.onTaskUpdating,
                                    onTaskInserted: $options.onTaskInserted,
                                    onTaskDeleted: $options.onTaskDeleted,
                                    onResourceAssigned: $options.onResourceAssigned,
                                    onResourceManagerDialogShowing: $options.onResourceManagerDialogShowing,
                                    onResourceUnassigned: $options.onResourceUnassigned,
                                    "task-title-position": $data.taskTitlePosition,
                                    "on-context-menu-preparing": _ctx.onContextMenuPreparing,
                                    allowTaskDeleting: "true",
                                    allowTaskAdding: "true",
                                    allowDependencyAdding: "true",
                                    allowDependencyDeleting: "false",
                                    allowResourceAdding: "false",
                                    allowResourceDeleting: "false",
                                    allowHeaderFiltering: "true",
                                    "show-dependencies": false,
                                    "show-resources": false
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxTasks, { "data-source": $data.tasks }, null, 8, ["data-source"]),
                                      _createVNode(_component_DxDependencies, { "data-source": $data.dependencies }, null, 8, ["data-source"]),
                                      _createVNode(_component_DxToolbar, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxItem, { name: "collapseAll" }),
                                          _createVNode(_component_DxItem, { name: "expandAll" }),
                                          _createVNode(_component_DxItem, { name: "separator" }),
                                          _createVNode(_component_DxItem, { name: "addTask" }),
                                          _createVNode(_component_DxItem, { name: "deleteTask" }),
                                          _createVNode(_component_DxItem, { name: "separator" }),
                                          _createVNode(_component_DxItem, { name: "zoomIn" }),
                                          _createVNode(_component_DxItem, { name: "zoomOut" }),
                                          _createVNode(_component_DxItem, { name: "separator" }),
                                          _createVNode(_component_DxItem, { name: "showDependencies" }),
                                          _createVNode(_component_DxItem, { name: "separator" }),
                                          _createVNode(_component_DxItem, {
                                            options: $data.exportXLSXButtonOptions,
                                            widget: "dxButton"
                                          }, null, 8, ["options"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxValidation, { "auto-update-parent-tasks": true }),
                                      _createVNode(_component_DxEditing, {
                                        enabled: true,
                                        "allow-task-resource-updating": false
                                      }),
                                      _createVNode(_component_DxStripLine, {
                                        start: $data.fechaInicio,
                                        title: "Inicio"
                                      }, null, 8, ["start"]),
                                      _createVNode(_component_DxStripLine, {
                                        start: $data.fechaFinal,
                                        title: "Final"
                                      }, null, 8, ["start"]),
                                      _createVNode(_component_DxStripLine, {
                                        start: $data.fechaActual,
                                        title: "Hoy",
                                        "css-class": "current-time"
                                      }, null, 8, ["start"]),
                                      _createVNode(_component_DxColumn, {
                                        width: 300,
                                        "data-field": "title",
                                        caption: "Actividad"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "start",
                                        caption: "Fecha Inicio",
                                        format: "shortDate",
                                        "data-type": "date"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "end",
                                        caption: "Fecha Fin",
                                        format: "shortDate",
                                        "data-type": "date"
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxHeaderFilter, {
                                        visible: true,
                                        width: 280,
                                        height: 350,
                                        "search-timeout": 800
                                      }),
                                      _createVNode(_component_DxContextMenu, { items: _ctx.contextMenuActualItems }, null, 8, ["items"])
                                    ]),
                                    _: 1
                                  }, 8, ["scale-type", "onTaskUpdating", "onTaskInserted", "onTaskDeleted", "onResourceAssigned", "onResourceManagerDialogShowing", "onResourceUnassigned", "task-title-position", "on-context-menu-preparing"])
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_57,
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn",
                                      onClick: _cache[19] || (_cache[19] = $event => (_ctx.onExporting3()))
                                    }, "Exportar")
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientos",
                                    "data-source": _ctx.dataSourceResultadosNO,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowInserted: _ctx.createRegister,
                                    onRowUpdated: _ctx.editProcedureResultado,
                                    onRowRemoved: _ctx.deleteRegister,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSelection, { mode: "single" }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": false,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptions,
                                        mode: "popup"
                                      }, null, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "habilidad",
                                        caption: "Materia",
                                        "group-index": 0
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "orden",
                                        caption: "Orden",
                                        visible: false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true } })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "descripcion",
                                        caption: "Descripcion"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 80, readOnly: true },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "valorno",
                                        caption: "NO",
                                        width: 130
                                      }),
                                      _createVNode(_component_DxColumn, { "data-field": "multas" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, { "data-field": "observacion" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, { "data-field": "recomendacion" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          }),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, { "data-field": "fundamentos" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxFormItem, {
                                            "col-span": 2,
                                            "editor-options": { height: 130 },
                                            "editor-type": "dxTextArea"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxGroupPanel, { visible: true }),
                                      _createVNode(_component_DxGrouping, { "auto-expand-all": _ctx.autoExpandAll }, null, 8, ["auto-expand-all"]),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false }),
                                      _createVNode(_component_DxColumnChooser, {
                                        enabled: false,
                                        mode: _ctx.mode
                                      }, null, 8, ["mode"])
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Etapa" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientosEtapa",
                                    "data-source": $data.dataSourceEtapaCierre,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowUpdated: $options.editRegisterCambioEtapa,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSelection, { mode: "single" }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": true,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptions3,
                                        mode: "popup"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxForm, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxItem, {
                                                "col-count": 2,
                                                "col-span": 2,
                                                "item-type": "group"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DxEmptyItem),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "etapaid",
                                                    caption: "Etapa",
                                                    "col-span": 2
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "etapaid",
                                        caption: "Etapa"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxLookup, {
                                            "data-source": $data.dataSourceEtapa,
                                            "value-expr": "id",
                                            "display-expr": "descripcion"
                                          }, null, 8, ["data-source"]),
                                          _createVNode(_component_DxValidationRule, { type: "required" }),
                                          _createVNode(_component_DxFormItem, { "col-span": 2 })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowUpdated", "onInitNewRow"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Estatus" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientosCambioCierre",
                                    "data-source": $data.dataSourceCambioEstatus,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowUpdated: $options.editRegisterCambioEstatus,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSelection, { mode: "single" }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": true,
                                        "allow-adding": false,
                                        "allow-deleting": false,
                                        popup: $data.popupOptionsEstatus,
                                        mode: "popup"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxForm, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxItem, {
                                                "col-count": 2,
                                                "col-span": 2,
                                                "item-type": "group"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DxEmptyItem),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "estatusid",
                                                    caption: "Estatus",
                                                    "col-span": 2
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "estatusid",
                                        caption: "Estatus"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxLookup, {
                                            "data-source": $data.dataSourceEstatus,
                                            "value-expr": "id",
                                            "display-expr": "descripcion"
                                          }, null, 8, ["data-source"]),
                                          _createVNode(_component_DxValidationRule, { type: "required" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowUpdated", "onInitNewRow"]),
                                  _createVNode(_component_DxPopup, {
                                    ref: "popaviso",
                                    height: 300,
                                    width: 650,
                                    title: $data.popup_aviso_Options,
                                    "close-on-outside-click": true,
                                    visible: $data.com_aviso_popupVisible,
                                    "onUpdate:visible": _cache[20] || (_cache[20] = $event => (($data.com_aviso_popupVisible) = $event)),
                                    "content-template": "popup-content",
                                    showCloseButton: "true"
                                  }, {
                                    "popup-content": _withCtx(() => [
                                      _createVNode(_component_DxScrollView, {
                                        height: "100%",
                                        width: "100%"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_59, [
                                            ($data.est_complementaria === 'S')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_62))
                                              : _createCommentVNode("", true),
                                            ($data.est_resolutivo === 'S')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["title", "visible"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Adjuntos" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_DxSelectBox, {
                                      "data-source": $data.dataSourceDocumento,
                                      "display-expr": "descripcion",
                                      "value-expr": "id",
                                      "show-clear-button": true,
                                      placeholder: "Seleccione Tipo de Documento",
                                      value: $data.valtipodocumento,
                                      "onUpdate:value": _cache[21] || (_cache[21] = $event => (($data.valtipodocumento) = $event))
                                    }, null, 8, ["data-source", "value"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_DxTextBox, {
                                      value: $data.valnombredocumento,
                                      "onUpdate:value": _cache[22] || (_cache[22] = $event => (($data.valnombredocumento) = $event)),
                                      placeholder: "Nombre de Documento"
                                    }, null, 8, ["value"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_DxFileUploader, {
                                      "select-button-text": "Seleccionar Documento",
                                      "label-text": "",
                                      accept: "*",
                                      "upload-mode": "useButtons",
                                      multiple: false,
                                      name: "file",
                                      "upload-url": $data.backendURL + '/api/archivoupload',
                                      onUploaded: _cache[23] || (_cache[23] = (e) => $options.onUploaded(e)),
                                      onUploadError: $options.onUploadError
                                    }, null, 8, ["upload-url", "onUploadError"])
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_DxDataGrid, {
                                    id: "procedimientos4",
                                    "data-source": $data.dataSourceDocumentacion,
                                    "allow-column-reordering": true,
                                    "column-auto-width": true,
                                    "show-row-lines": true,
                                    "show-borders": true,
                                    "word-wrap-enabled": true,
                                    "key-expr": "id",
                                    onRowInserted: _ctx.createRegister,
                                    onRowRemoved: $options.deleteProcedureDocumento,
                                    onInitNewRow: $options.onInitNewRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: true }),
                                      _createVNode(_component_DxSorting, { mode: "multiple" }),
                                      _createVNode(_component_DxScrolling, { mode: "standard" }),
                                      _createVNode(_component_DxPaging, {
                                        enabled: true,
                                        "page-size": 100
                                      }),
                                      _createVNode(_component_DxPager, {
                                        "show-page-size-selector": true,
                                        "allowed-page-sizes": _ctx.allowedPageSizes,
                                        "show-info": true
                                      }, null, 8, ["allowed-page-sizes"]),
                                      _createVNode(_component_DxEditing, {
                                        "allow-updating": false,
                                        "allow-adding": false,
                                        "allow-deleting": true,
                                        popup: $data.popupOptions2,
                                        mode: "popup"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxForm, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DxItem, {
                                                "col-count": 1,
                                                "col-span": 2,
                                                "item-type": "group"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "tipodocumento",
                                                    caption: "Tipo Documento"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "nombredocumento",
                                                    caption: "Nombre Documento"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "usuarioregistro",
                                                    caption: "Usuario Registro"
                                                  }),
                                                  _createVNode(_component_DxItem, {
                                                    "data-field": "fecharegistro",
                                                    caption: "Fecha Registro"
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["popup"]),
                                      _createVNode(_component_DxColumn, {
                                        type: "buttons",
                                        width: 100
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxButton, {
                                            hint: "Descargar Documento",
                                            icon: "download",
                                            onClick: $options.downloadfile
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_DxButton, { name: "delete" })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "tipodocumento",
                                        caption: "Tipo Documento"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "nombredocumento",
                                        caption: "Nombre Documento"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "usuarioregistro",
                                        caption: "Usuario Registro"
                                      }),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "fecharegistro",
                                        caption: "Fecha Registro"
                                      }),
                                      _createVNode(_component_DxFilterRow, { visible: true }),
                                      _createVNode(_component_DxSearchPanel, { visible: false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "onRowInserted", "onRowRemoved", "onInitNewRow"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Emision/Complementaria" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _hoisted_66,
                                  ($data.est_resolutivo === 'N')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                        _createVNode(_component_DxDataGrid, {
                                          id: "dgResolutov",
                                          "data-source": $data.dataSourceResolutivo,
                                          "allow-column-reordering": true,
                                          "column-auto-width": true,
                                          "show-row-lines": true,
                                          "show-borders": true,
                                          "word-wrap-enabled": true,
                                          "key-expr": "id",
                                          onRowInserted: _ctx.createRegister,
                                          onInitNewRow: $options.onInitNewRow,
                                          onRowUpdated: $options.editResolutivo
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DxFilterRow, { visible: true }),
                                            _createVNode(_component_DxSearchPanel, { visible: true }),
                                            _createVNode(_component_DxSorting, { mode: "multiple" }),
                                            _createVNode(_component_DxScrolling, { mode: "standard" }),
                                            _createVNode(_component_DxPaging, {
                                              enabled: true,
                                              "page-size": 100
                                            }),
                                            _createVNode(_component_DxPager, {
                                              "show-page-size-selector": true,
                                              "allowed-page-sizes": _ctx.allowedPageSizes,
                                              "show-info": true
                                            }, null, 8, ["allowed-page-sizes"]),
                                            _createVNode(_component_DxEditing, {
                                              "allow-updating": false,
                                              "allow-adding": false,
                                              "allow-deleting": false,
                                              popup: $data.popupOptions_edicion_resolutivo,
                                              mode: "popup"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxForm, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_DxItem, {
                                                      "col-count": 3,
                                                      "col-span": 2,
                                                      "item-type": "group"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "fecharesolutivo",
                                                          caption: "Fecha Emisión Resolutivo"
                                                        }),
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "fechavigenciaresolutivo",
                                                          caption: "Fecha Vigencia Resolutivo"
                                                        }),
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "vigenciaresolutivo",
                                                          caption: "Vigencia"
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["popup"]),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "fecharesolutivo",
                                              caption: "Fecha Emisión Resolutivo",
                                              "data-type": "date"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxValidationRule, { type: "required" })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "fechavigenciaresolutivo",
                                              caption: "Fecha Vigencia Resolutivo",
                                              "data-type": "date"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true }  })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "vigenciaresolutivo",
                                              caption: "Vigencia"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxLookup, {
                                                  "data-source": $data.dataSourceVigencia,
                                                  "value-expr": "id",
                                                  "display-expr": "descripcion"
                                                }, null, 8, ["data-source"]),
                                                _createVNode(_component_DxValidationRule, { type: "required" })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_DxFilterRow, { visible: true }),
                                            _createVNode(_component_DxSearchPanel, { visible: false })
                                          ]),
                                          _: 1
                                        }, 8, ["data-source", "onRowInserted", "onInitNewRow", "onRowUpdated"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  ($data.est_resolutivo === 'S')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                        _createVNode(_component_DxDataGrid, {
                                          id: "dgResolutov",
                                          "data-source": $data.dataSourceResolutivo,
                                          "allow-column-reordering": true,
                                          "column-auto-width": true,
                                          "show-row-lines": true,
                                          "show-borders": true,
                                          "word-wrap-enabled": true,
                                          "key-expr": "id",
                                          onRowInserted: _ctx.createRegister,
                                          onInitNewRow: $options.onInitNewRow,
                                          onRowUpdated: $options.editResolutivo
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DxFilterRow, { visible: true }),
                                            _createVNode(_component_DxSearchPanel, { visible: true }),
                                            _createVNode(_component_DxSorting, { mode: "multiple" }),
                                            _createVNode(_component_DxScrolling, { mode: "standard" }),
                                            _createVNode(_component_DxPaging, {
                                              enabled: true,
                                              "page-size": 100
                                            }),
                                            _createVNode(_component_DxPager, {
                                              "show-page-size-selector": true,
                                              "allowed-page-sizes": _ctx.allowedPageSizes,
                                              "show-info": true
                                            }, null, 8, ["allowed-page-sizes"]),
                                            _createVNode(_component_DxEditing, {
                                              "allow-updating": true,
                                              "allow-adding": false,
                                              "allow-deleting": false,
                                              popup: $data.popupOptions_edicion_resolutivo,
                                              mode: "popup"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxForm, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_DxItem, {
                                                      "col-count": 3,
                                                      "col-span": 2,
                                                      "item-type": "group"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "fecharesolutivo",
                                                          caption: "Fecha Emisión Resolutivo"
                                                        }),
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "fechavigenciaresolutivo",
                                                          caption: "Fecha Vigencia Resolutivo"
                                                        }),
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "vigenciaresolutivo",
                                                          caption: "Vigencia"
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["popup"]),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "fecharesolutivo",
                                              caption: "Fecha Emisión Resolutivo",
                                              "data-type": "date"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxValidationRule, { type: "required" })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "fechavigenciaresolutivo",
                                              caption: "Fecha Vigencia Resolutivo",
                                              "data-type": "date"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxFormItem, { "editor-options": { readOnly: true }  })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "vigenciaresolutivo",
                                              caption: "Vigencia"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxLookup, {
                                                  "data-source": $data.dataSourceVigencia,
                                                  "value-expr": "id",
                                                  "display-expr": "descripcion"
                                                }, null, 8, ["data-source"]),
                                                _createVNode(_component_DxValidationRule, { type: "required" })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_DxFilterRow, { visible: true }),
                                            _createVNode(_component_DxSearchPanel, { visible: false })
                                          ]),
                                          _: 1
                                        }, 8, ["data-source", "onRowInserted", "onInitNewRow", "onRowUpdated"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_69,
                                  ($data.est_complementaria === 'N')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                        _createVNode(_component_DxDataGrid, {
                                          id: "dgComplementaria",
                                          "data-source": $data.dataSourceComplementaria,
                                          "allow-column-reordering": true,
                                          "column-auto-width": true,
                                          "show-row-lines": true,
                                          "show-borders": true,
                                          "word-wrap-enabled": true,
                                          "key-expr": "id",
                                          onRowInserted: $options.createComplementaria,
                                          onRowUpdated: $options.editComplementaria,
                                          onRowRemoved: $options.deleteComplementaria,
                                          onInitNewRow: $options.onInitNewRow
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DxFilterRow, { visible: true }),
                                            _createVNode(_component_DxSearchPanel, { visible: true }),
                                            _createVNode(_component_DxSorting, { mode: "multiple" }),
                                            _createVNode(_component_DxScrolling, { mode: "standard" }),
                                            _createVNode(_component_DxPaging, {
                                              enabled: true,
                                              "page-size": 100
                                            }),
                                            _createVNode(_component_DxPager, {
                                              "show-page-size-selector": true,
                                              "allowed-page-sizes": _ctx.allowedPageSizes,
                                              "show-info": true
                                            }, null, 8, ["allowed-page-sizes"]),
                                            _createVNode(_component_DxEditing, {
                                              "allow-updating": false,
                                              "allow-adding": false,
                                              "allow-deleting": false,
                                              popup: $data.popupOptions_edicion_complementario,
                                              mode: "popup"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxForm, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_DxItem, {
                                                      "col-count": 2,
                                                      "col-span": 2,
                                                      "item-type": "group"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "informacion",
                                                          caption: "Información Complementaria",
                                                          "col-count": 2,
                                                          "col-span": 2
                                                        }),
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "entregado",
                                                          caption: "Entregado"
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["popup"]),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "informacion",
                                              caption: "Información Complementaria"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxFormItem, {
                                                  "col-span": 2,
                                                  "editor-options": { height: 100 } ,
                                                  "editor-type": "dxTextArea"
                                                }),
                                                _createVNode(_component_DxValidationRule, { type: "required" })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "entregado",
                                              caption: "Entregado",
                                              "data-type": "boolean",
                                              width: 130
                                            }),
                                            _createVNode(_component_DxFilterRow, { visible: true }),
                                            _createVNode(_component_DxSearchPanel, { visible: false })
                                          ]),
                                          _: 1
                                        }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  ($data.est_complementaria === 'S')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                        _createVNode(_component_DxDataGrid, {
                                          id: "dgComplementaria",
                                          "data-source": $data.dataSourceComplementaria,
                                          "allow-column-reordering": true,
                                          "column-auto-width": true,
                                          "show-row-lines": true,
                                          "show-borders": true,
                                          "word-wrap-enabled": true,
                                          "key-expr": "id",
                                          onRowInserted: $options.createComplementaria,
                                          onRowUpdated: $options.editComplementaria,
                                          onRowRemoved: $options.deleteComplementaria,
                                          onInitNewRow: $options.onInitNewRow
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DxFilterRow, { visible: true }),
                                            _createVNode(_component_DxSearchPanel, { visible: true }),
                                            _createVNode(_component_DxSorting, { mode: "multiple" }),
                                            _createVNode(_component_DxScrolling, { mode: "standard" }),
                                            _createVNode(_component_DxPaging, {
                                              enabled: true,
                                              "page-size": 100
                                            }),
                                            _createVNode(_component_DxPager, {
                                              "show-page-size-selector": true,
                                              "allowed-page-sizes": _ctx.allowedPageSizes,
                                              "show-info": true
                                            }, null, 8, ["allowed-page-sizes"]),
                                            _createVNode(_component_DxEditing, {
                                              "allow-updating": true,
                                              "allow-adding": true,
                                              "allow-deleting": true,
                                              popup: $data.popupOptions_edicion_complementario,
                                              mode: "popup"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxForm, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_DxItem, {
                                                      "col-count": 2,
                                                      "col-span": 2,
                                                      "item-type": "group"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "informacion",
                                                          caption: "Información Complementaria",
                                                          "col-count": 2,
                                                          "col-span": 2
                                                        }),
                                                        _createVNode(_component_DxItem, {
                                                          "data-field": "entregado",
                                                          caption: "Entregado"
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["popup"]),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "informacion",
                                              caption: "Información Complementaria"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxFormItem, {
                                                  "col-span": 2,
                                                  "editor-options": { height: 100 } ,
                                                  "editor-type": "dxTextArea"
                                                }),
                                                _createVNode(_component_DxValidationRule, { type: "required" })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "entregado",
                                              caption: "Entregado",
                                              "data-type": "boolean",
                                              width: 130
                                            }),
                                            _createVNode(_component_DxFilterRow, { visible: true }),
                                            _createVNode(_component_DxSearchPanel, { visible: false })
                                          ]),
                                          _: 1
                                        }, 8, ["data-source", "onRowInserted", "onRowUpdated", "onRowRemoved", "onInitNewRow"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DxItem, { title: "Historial de Cambios" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDataGrid, {
                                  id: "procedimientos3",
                                  "data-source": $data.dataSourceHistorial,
                                  "allow-column-reordering": true,
                                  "column-auto-width": true,
                                  "show-row-lines": true,
                                  "show-borders": true,
                                  "word-wrap-enabled": true,
                                  "key-expr": "id",
                                  onRowInserted: _ctx.createRegister,
                                  onRowRemoved: _ctx.deleteRegister,
                                  onInitNewRow: $options.onInitNewRow
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSearchPanel, { visible: true }),
                                    _createVNode(_component_DxSorting, { mode: "multiple" }),
                                    _createVNode(_component_DxScrolling, { mode: "standard" }),
                                    _createVNode(_component_DxPaging, {
                                      enabled: true,
                                      "page-size": 100
                                    }),
                                    _createVNode(_component_DxPager, {
                                      "show-page-size-selector": true,
                                      "allowed-page-sizes": _ctx.allowedPageSizes,
                                      "show-info": true
                                    }, null, 8, ["allowed-page-sizes"]),
                                    _createVNode(_component_DxEditing, {
                                      "allow-updating": false,
                                      "allow-adding": false,
                                      "allow-deleting": false,
                                      popup: $data.popupOptions2,
                                      mode: "popup"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxForm, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DxItem, {
                                              "col-count": 1,
                                              "col-span": 2,
                                              "item-type": "group"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "tipocambio",
                                                  caption: "Cambio"
                                                }),
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "situacionorigen",
                                                  caption: "Situacion Origen"
                                                }),
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "situaciondestino",
                                                  caption: "Situacion Destino"
                                                }),
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "usuarioregistro",
                                                  caption: "Usuario Registro"
                                                }),
                                                _createVNode(_component_DxItem, {
                                                  "data-field": "fecharegistro",
                                                  caption: "Fecha Registro"
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["popup"]),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "tipocambio",
                                      caption: "Cambio"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "situacionorigen",
                                      caption: "Situacion Origen"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "situaciondestino",
                                      caption: "Situacion Destino"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "usuarioregistro",
                                      caption: "Usuario Registro"
                                    }),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "fecharegistro",
                                      caption: "Fecha Registro"
                                    }),
                                    _createVNode(_component_DxFilterRow, { visible: true }),
                                    _createVNode(_component_DxSearchPanel, { visible: false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "onRowInserted", "onRowRemoved", "onInitNewRow"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["form-data"])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}